import React, { useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import CasinoBtnSave from '../../../../../components/casino/CasinoBtnSave';
import useNumberParams from '../../../../../hooks/useNumberParams';
import { API_CASINO } from '../../../../../api/casino';
import useToast from '../../../../../hooks/useToast';
import CodeEditor from '../../../../../components/material-ui/code_editor/CodeEditor';
import { setCasinoActionsConfig } from '../../../../../store/apps/userSlice';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../../../store';

export default function ProvidersSettingContent() {
  const casinoId = useNumberParams('casinoId');
  const { successToast } = useToast();
  const dispatch = useDispatch();
  const enabledBtn = useAppSelector((state) => state.user.casinoActions.config);
  const [textConfig, setTextConfig] = useState('');

  useEffect(() => {
    API_CASINO.config
      .get({ casinoId, config: 'paysys' })
      .then((e) => {
        const data = e.data.data;
        setTextConfig(data.paysys);
        dispatch(setCasinoActionsConfig(data.editable));
      })
      .catch(console.error);
  }, [casinoId]);

  const onSaveClick = () => {
    API_CASINO.config
      .set({ casinoId, data: { paysys: textConfig } })
      .then((e) => {
        successToast('Successfully updated');
      })
      .catch(console.error);
  };

  return (
    <Stack display={'flex'} direction={'column'} gap={1} flex={1}>
      <CodeEditor text={textConfig} setText={setTextConfig} readOnly={!enabledBtn} />
      <CasinoBtnSave onClick={onSaveClick} disabled={!enabledBtn} />
    </Stack>
  );
}
